import { useState } from "react"
import { useSession } from "@hooks/useSession"
import Sidebar from "../components/dashboard/Sidebar"
import DashboardHeader from "../components/dashboard/HeaderDashboard"
import CROSettings from "../components/settings/CROSettings"
import InvestigatorSettings from "../components/settings/InvestigatorSettings"
import State,{STATE, AppContextState } from "@state"
import NavigationService from "@services/navigation.service.js";
import AuthController from "@controllers/auth.controller.js";


export default function Settings() {
  const { user } = useSession() 
  const isCRO = STATE[AppContextState.ROLE_CONTEXT] === AppContextState.ROLE_CONTEXT_CRO 


  const croTabs = ["Company information", "Security"]
  const investigatorTabs = ["Investigator information", "Security"]


  const tabButtons = isCRO ? croTabs : investigatorTabs

  const [activeTab, setActiveTab] = useState(tabButtons[0])

  // Handle create study
  const handleCreateStudy = () => {
    NavigationService.navigateTo("/create-study")
  }

  // Handle sign out
  const handleSignOut = () => {
    AuthController.logout();
  }

  return (
    <div className="flex h-screen bg-dashboard-bg">
      <Sidebar
        title="OSHIMED"
        activeLink="Settings"
        companyName="Company Name"
        onCreateStudy={handleCreateStudy}
        onSignOut={handleSignOut}
      />
      
         
 
            {isCRO ? (
           
              <CROSettings activeTab={activeTab} />
            ) : (
            
              <InvestigatorSettings activeTab={activeTab} />
            )}
 
        </div>

  )
}
